import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/api";
import { useState } from "react";
import { Menu, X, LogOut, User, Shield, Building2 } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  const links = [
    { to: "/jobs", label: "Jobs" },
    { to: "/community", label: "Community" },
    { to: "/resume-builder", label: "Resume Builder" },
    { to: "/resources", label: "Resources" },
    { to: "/legal/safety", label: "Safety" },
  ];

  const linkClass = ({ isActive }) =>
    `px-3 py-2 font-bold uppercase text-sm tracking-wide ${isActive ? "text-[var(--nh-primary)]" : "text-black hover:text-[var(--nh-primary)]"}`;

  return (
    <header className="sticky top-0 z-40 bg-[var(--nh-bg)]/85 backdrop-blur border-b-2 border-black">
      <div className="nh-container flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo-link">
          <img src={LOGO_URL} alt="NextHire" className="h-10 w-10 rounded-md object-cover border-2 border-black" />
          <span className="font-display font-black text-xl tracking-tight">NextHire</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} className={linkClass} data-testid={`nav-${l.label.toLowerCase().replace(/\s/g,'-')}`}>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2">
          {user ? (
            <>
              {user.role === "admin" && (
                <Link to="/admin" className="nh-btn nh-btn-ghost text-xs" data-testid="nav-admin">
                  <Shield size={14}/> Admin
                </Link>
              )}
              {user.role === "employer" && (
                <Link to="/employer" className="nh-btn nh-btn-ghost text-xs" data-testid="nav-employer">
                  <Building2 size={14}/> Employer
                </Link>
              )}
              {user.role === "youth" && (
                <Link to="/dashboard" className="nh-btn nh-btn-ghost text-xs" data-testid="nav-dashboard">
                  <User size={14}/> Dashboard
                </Link>
              )}
              <button onClick={async ()=>{ await logout(); nav("/"); }} className="nh-btn nh-btn-primary text-xs" data-testid="nav-logout">
                <LogOut size={14}/> Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="nh-btn nh-btn-ghost text-xs" data-testid="nav-login">Log in</Link>
              <Link to="/signup" className="nh-btn nh-btn-primary text-xs" data-testid="nav-signup">Get Started</Link>
            </>
          )}
        </div>

        <button className="md:hidden p-2 border-2 border-black rounded-lg" onClick={()=>setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X/> : <Menu/>}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t-2 border-black bg-white">
          <div className="nh-container py-4 flex flex-col gap-2">
            {links.map((l)=>(
              <Link key={l.to} to={l.to} onClick={()=>setOpen(false)} className="py-2 font-bold uppercase" data-testid={`mnav-${l.label.toLowerCase().replace(/\s/g,'-')}`}>
                {l.label}
              </Link>
            ))}
            <div className="flex gap-2 pt-2">
              {user ? (
                <>
                  {user.role === "youth" && <Link to="/dashboard" onClick={()=>setOpen(false)} className="nh-btn nh-btn-ghost text-xs">Dashboard</Link>}
                  {user.role === "employer" && <Link to="/employer" onClick={()=>setOpen(false)} className="nh-btn nh-btn-ghost text-xs">Employer</Link>}
                  {user.role === "admin" && <Link to="/admin" onClick={()=>setOpen(false)} className="nh-btn nh-btn-ghost text-xs">Admin</Link>}
                  <button onClick={async ()=>{ await logout(); setOpen(false); nav("/"); }} className="nh-btn nh-btn-primary text-xs">Logout</button>
                </>
              ) : (
                <>
                  <Link to="/login" onClick={()=>setOpen(false)} className="nh-btn nh-btn-ghost text-xs">Log in</Link>
                  <Link to="/signup" onClick={()=>setOpen(false)} className="nh-btn nh-btn-primary text-xs">Get Started</Link>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
